module.exports = __webpack_public_path__ + "img/pic_huaweistepone.8fc83740.png";